module.exports = __webpack_public_path__ + "img/developers.0319a794.png";